import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Employee360Repository } from '../../../infrastructure/repositories/employee-360.repository';
import { SearchEmployeesQuery } from './search-employees.query';
import { SearchEmployeesResult } from './search-employees.result';

/**
 * Search employees use case.
 * Used by the global header search to populate the employee dropdown.
 */
@Injectable({ providedIn: 'root' })
export class SearchEmployeesUseCase {
  private readonly _repository = inject(Employee360Repository);

  public execute(query: SearchEmployeesQuery): Observable<SearchEmployeesResult> {
    return this._repository
      .searchEmployees(query.term)
      .pipe(map((employees) => ({ employees })));
  }
}
